import { render, staticRenderFns } from "./fansMessage.vue?vue&type=template&id=31cc7a7a&scoped=true"
import script from "./fansMessage.vue?vue&type=script&lang=js"
export * from "./fansMessage.vue?vue&type=script&lang=js"
import style0 from "./fansMessage.vue?vue&type=style&index=0&id=31cc7a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cc7a7a",
  null
  
)

export default component.exports